// extracted by mini-css-extract-plugin
export var notificationHost = "_ch-0";